export interface FontSizeChangeButton {
  id: ButtonID;
  fontSize: string;
  value: string;
}

export enum ButtonID {
  DECREASE_SIZE = 'decrease_size',
  DEFAULT_SIZE = 'default_size',
  INCREASE_SIZE = 'increase_size',
}

export enum FontSizeChangeValue {
  DECREASE_SIZE = '-2px',
  DEFAULT_SIZE = '0px',
  INCREASE_SIZE = '2px',
}
